// import React from "react";
// import "./common.css";
// import logo from "../../assets/images/logo.jpg";
// import { menu } from "../../constants/js/menu";
// import { Link, NavLink, useHistory } from "react-router-dom";

// const Base = (props) => {
//   const history = useHistory();

//   const handleLogout = () => {
//     localStorage.clear();
//     history.push("/login");
//     // اگر مایلید والد را در جریان قرار دهید (مثلاً برای تغییر استیت لاگین):
//     if (props.changeState) {
//       props.changeState(false);
//     }
//   };

//   return (
//     <div className="d-flex">
//       <div className="sidebar-container">
//         <img src={logo} width={200} height={200} />
//         v1.29
//         <div className="divider"></div>
//         <div className="menu-list-container">
//           {menu.sidebar.map((item) => (
//             <NavLink
//               exact
//               activeClassName="is-active"
//               to={item.url}
//               key={item.label}
//             >
//               {item.label}
//             </NavLink>
//           ))}
//           <div
//             onClick={() => {
//               localStorage.clear();
//               history.push("/login");
//               props.changeState(false);
//             }}
//             className={"cursor-pointer my-3"}
//           >
//             {"خروج"}
//           </div>
//         </div>
//       </div>
//       <div className="container-fluid">
//         <div className="row">{props.children}</div>
//       </div>
//       {/*</div>*/}
//     </div>
//   );
// };

// export default Base;
import React, { useState, useEffect, useContext } from "react";
import "./common.css";
import logo from "../../assets/images/logo.png";
import { menu } from "../../constants/js/menu";
import { NavLink, useHistory } from "react-router-dom";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import exitIcon from "../../svg/exitIcon.svg";
import {
  FaAlignRight,
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
} from "react-icons/fa";
import { WindowSizeContext } from "../../Context/WindowSizeContext";

const Base = (props) => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const history = useHistory();
  const { isMobile } = useContext(WindowSizeContext);

  const handleLogout = () => {
    localStorage.clear();
    history.push("/login");
    if (props.changeState) {
      props.changeState(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 768) {
        setCollapsed(false);
      } else if (width <= 1200) {
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="d-flex flex-column w-100">
      {isMobile && (
        <div className="mobile-header">
          <button
            className="btn btn-sm  btn-secondary"
            onClick={() => setIsMobileMenuOpen(true)}
          >
            {<FaAlignRight color="white" />}
          </button>
        </div>
      )}

      {isMobile && isMobileMenuOpen && (
        <div className="mobile-menu-overlay">
          <div className="mobile-menu-header">
            <button onClick={() => setIsMobileMenuOpen(false)}>✖</button>
          </div>
          <Sidebar collapsed={false}>
            <Menu>
              {menu.sidebar.map((item) => (
                <MenuItem
                  key={item.label}
                  icon={item.icon}
                  onClick={() => setIsMobileMenuOpen(false)}
                  component={
                    <NavLink exact to={item.url} activeClassName="is-active" />
                  }
                >
                  {item.label}
                </MenuItem>
              ))}
              <MenuItem
                icon={<img src={exitIcon} width={22} />}
                onClick={handleLogout}
              >
                خروج
              </MenuItem>
            </Menu>
          </Sidebar>
        </div>
      )}

      {!isMobile && (
        <div className={`sidebar-fixed ${collapsed ? "collapsed" : ""}`}>
          <Sidebar collapsed={collapsed}>
            {!collapsed && (
              <div style={{ textAlign: "center", margin: "1rem 0" }}>
                <img
                  src={logo}
                  width={80}
                  height={80}
                  alt="logo"
                  style={{ borderRadius: "50px" }}
                />
                <p>v1.5</p>
              </div>
            )}
            <Menu>
              {menu.sidebar.map((item) => (
                <MenuItem
                  key={item.label}
                  icon={item.icon}
                  component={
                    <NavLink exact to={item.url} activeClassName="is-active" />
                  }
                >
                  {item.label}
                </MenuItem>
              ))}
              <MenuItem
                icon={<img src={exitIcon} width={22} />}
                onClick={handleLogout}
              >
                خروج
              </MenuItem>
              <MenuItem>
                <div className="text-end ">
                  <button
                    style={{ backgroundColor: "#e5e5e536" }}
                    onClick={() => setCollapsed(!collapsed)}
                    className="btn btn-sm "
                  >
                    {collapsed ? <FaAngleDoubleLeft /> : <FaAngleDoubleRight />}
                  </button>
                </div>
              </MenuItem>
            </Menu>
          </Sidebar>
        </div>
      )}

      <div
        className={`main-content ${collapsed && !isMobile ? "collapsed" : ""}`}
      >
        <div className="container-fluid">
          <div className="row">{props.children}</div>
        </div>
      </div>
    </div>
  );
};

export default Base;
